import { DateTime } from 'luxon';
import * as Yup from 'yup';
var verificationSchema = Yup.object().shape({
    dateOfBirth: Yup.mixed()
        .test('valid-date', 'Please enter a valid date', function (val) {
        var date = DateTime.fromFormat(val, 'dd/MM/yyyy');
        return date.isValid;
    })
        .test('valid-length', 'Please enter a valid date', function (val) {
        return val ? val.replace(/[/_]/g, '').length === 8 : false;
    })
        .test('is-of-age', 'You must be 18 years or older to sign up ', function (val) {
        var currentDate = DateTime.now();
        var birthDate = DateTime.fromFormat(val, 'dd/MM/yyyy');
        var diff = birthDate.diff(currentDate, 'years');
        return diff.as('years') >= 18;
    }),
    lastName: Yup.string()
        .test('empty-check', 'Please enter your last name', function (val) { return val.length > 0; })
        .max(100, 'Last name is too long')
        .required('Please enter your surname'),
});
export { verificationSchema };
//# sourceMappingURL=validation.js.map